import React from 'react';
import { Dropdown, Avatar, Typography, MenuProps } from 'antd';
import { UserOutlined, LogoutOutlined, GlobalOutlined, CheckOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '../i18n';

const { Text } = Typography;

interface UserInfo { email: string; role: string; }

export default function SidebarUserMenu({ user, collapsed }: { user: UserInfo | null; collapsed: boolean }) {
  const { t, i18n } = useTranslation();
  const qc = useQueryClient();
  const navigate = useNavigate();

  const items: MenuProps['items'] = [
    {
      key: 'email',
      label: <Text type="secondary" style={{ fontSize: 12 }}>{user?.email}</Text>,
      disabled: true,
    },
    { type: 'divider' },
    {
      key: 'lang-en',
      label: 'English',
      icon: <GlobalOutlined />,
      onClick: () => setLanguage('en'),
      ...(i18n.language === 'en' ? { extra: <CheckOutlined style={{ color: '#3b82f6' }} /> } : {}),
    },
    {
      key: 'lang-he',
      label: 'עברית',
      icon: <GlobalOutlined />,
      onClick: () => setLanguage('he'),
      ...(i18n.language === 'he' ? { extra: <CheckOutlined style={{ color: '#3b82f6' }} /> } : {}),
    },
    { type: 'divider' },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('nav.signOut'),
      danger: true,
      onClick: () => {
        localStorage.removeItem('token');
        qc.clear();
        navigate('/app/login');
      },
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="topLeft">
      <div
        style={{
          display: 'flex', alignItems: 'center', gap: 10, padding: '14px 16px',
          color: '#f2f2f0', cursor: 'pointer',
        }}
      >
        <Avatar size={30} icon={<UserOutlined />} style={{ flexShrink: 0, background: '#e8c642', color: '#5c4a0e' }}>
          {user?.email ? user.email.slice(0, 2).toUpperCase() : undefined}
        </Avatar>
        {!collapsed && (
          <span style={{ fontSize: 12.5, color: '#9a9a97', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {user?.email ?? '—'}
          </span>
        )}
      </div>
    </Dropdown>
  );
}
